<template>
  <div
    :class="[
      'media-links',
      'pt-2xl',
      'px-2xl',
      dimensions.width < 600 ? 'hide' : ''
    ]"
  >
    <a
      v-for="item in children"
      :key="item.title"
      @click.prevent="clickHandler(item)"
      href="#media-link"
      class="media-links--thumb"
    >
      <div class="media-links--thumb--img">
        <i
          :class="[
            'media-icon',
            'fal',
            isVideo(item) ? 'fa-play-circle' : 'fa-plus'
          ]"
        ></i>
        <img :src="parseSrc(item.image)" :alt="item.title" />
        <!--`${$imageFolder}/${item.image}`-->
      </div>
      <h5 v-if="item.title" v-text="item.title"></h5>
    </a>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    children: {
      type: Array,
      required: true
    }
  },
  watch: {
    mediaChildren() {
      this.setMediaChildrenToGallery();
    }
  },
  mounted() {
    // console.log("MEDIA CHILDREN > ", this.mediaChildren);
    this.setMediaChildrenToGallery();
  },
  methods: {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    parseSrc(img) {
      // console.log(" >this.$imageFolder >> ", this.$imageFolder);
      if (/http/.test(img)) {
        return img;
      }
      return `${this.$imageFolder}/${img}`;
    },
    isVideo(item) {
      return item.media_type_id === 5;
    },
    setMediaChildrenToGallery() {
      this.$nextTick(function() {
        if (this.mediaChildren && this.mediaChildren.length) {
          this.setGalleryChildren(this.mediaChildren);
        }
      });
    },
    clickHandler(item) {
      if (this.isMedia(item)) {
        let id = item.id,
          index = _.findIndex(this.mediaChildren, { id });
        // console.log("ITEM > ", item);
        this.setGalleryIndex(index);
      } else if (this.isExternalLink) {
        window.open(item.url, "_blank");
      } else {
        this.$router.push(item.url);
      }
    },
    isMedia(item) {
      return item.url && /(vimeo|youtube)/g.test(item.url);
    },
    isExternalLink(item) {
      return item.url && /http/.test(item.url);
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    mediaChildren() {
      return _.filter(
        this.children,
        child => child.url && /(vimeo|youtube)/g.test(child.url)
      );
    }
  }
};
</script>
<style lang="stylus">
.media-links
  background #fff
  min-height 10vh
  _flex(column, nowrap, flex-start, flex-start)
  +above(600px)
    _flex(row, wrap, stretch, space-between)
  &--thumb
    flex 1
    pad('2xl', bottom)
    +above(600px)
      flex 0 0 30%
      margin 0 10px 20px
      padding-bottom 20px
      _flex(column, nowrap, flex-start, flex-start)
    &--img
      overflow hidden
      width 100%
      flex 0 0 75%
      position relative
      _flex(column, nowrap, center, center)
      &:after
        content ''
        position absolute 0 0 0 0
        opacity 0
        background rgba(gray_8, 0.2) url(/img/dark-net.png) repeat 0 0
        z-index 8
        transition opacity 0.7s ease-out-expo
      img
        position relative
        max-width 112%
        min-height 100%
        min-width 100%
        transition transform 0.7s ease-out-expo
    .media-icon
      opacity 0
      backface-visibility hidden
      center()
      transform translate(-50%, -50%) scale(0.5)
      z-index 9
      font-size responsive 76px 96px
      color rgba(#fff, 0.9)
      transition opacity 0.7s ease-out-expo, transform 0.7s ease-out-expo
    +desktop()
      &:hover
        .media-links--thumb--img
          &:after
            opacity 0.4
          img
            transform scale(1.1)
          .media-icon
            opacity 1
            transform translate(-50%, -50%) scale(1)
    +above(600px)
      flex 1
      // marg('2xl', x)
      // margin 0 5px
    &:first-child
      margin-left 0
    &:last-child
      margin-right 0
    h5
      color gray_8
      position relative
      pad('s', top)
      +above(600px)
        pad('l', top)
      &:after
        content ''
        position absolute
        left 0
        width 30%
        min-width 80px
        height 1px
        background gray_5
        bottom -4px
        +above(600px)
          bottom -8px
</style>
